// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"2bf6e86e","917":"3093da3b"}[chunkId] + ".chunk.js";
};